import { useMemo } from 'react';
import { useCore } from '$api-clients/hooks';

export function useClientGroup(id?: string | null) {
  const { data, isLoading, error, mutate } = useCore(
    '/client-groups/{clientGroupId}',
    id ? { params: { path: { clientGroupId: id } } } : null,
  );

  const clientGroup = useMemo(() => {
    if (!data) return undefined;
    const contacts = data.contacts ?? [];
    return {
      ...data,
      clients: contacts.filter((c) => c.type === 'client'),
      agents: contacts.filter((c) => c.type === 'agent'),
    };
  }, [data]);

  return {
    clientGroup,
    loading: isLoading,
    error,
    mutate,
  };
}
